var _defs, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAcgIcons04Black = function SvgAcgIcons04Black(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#000;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2330.93,
    cy: 249.81,
    r: 166
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2330.93,
    cy: 249.81,
    r: 137.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2330.93,
    cy: 249.81,
    r: 108.26
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150,
    y: 144.1,
    width: 200,
    height: 16.95,
    rx: 3.97,
    transform: "translate(181.11 -132.09) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150,
    y: 338.95,
    width: 200,
    height: 16.95,
    rx: 3.97,
    transform: "translate(-172.44 278.53) rotate(-45)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAcgIcons04Black);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNTAwIDUwMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiMwMDA7fS5jbHMtM3tjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgpO30uY2xzLTR7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTIpO30uY2xzLTV7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTMpO308L3N0eWxlPjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjIzMzAuOTMiIGN5PSIyNDkuODEiIHI9IjE2NiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgtMiI+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyMzMwLjkzIiBjeT0iMjQ5LjgxIiByPSIxMzcuMTMiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoLTMiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjMzMC45MyIgY3k9IjI0OS44MSIgcj0iMTA4LjI2Ii8+PC9jbGlwUGF0aD48L2RlZnM+PHJlY3QgY2xhc3M9ImNscy0yIiB4PSIxNTAiIHk9IjE0NC4xIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE2Ljk1IiByeD0iMy45NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTgxLjExIC0xMzIuMDkpIHJvdGF0ZSg0NSkiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjE1MCIgeT0iMzM4Ljk1IiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE2Ljk1IiByeD0iMy45NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3Mi40NCAyNzguNTMpIHJvdGF0ZSgtNDUpIi8+PC9zdmc+Cg==";